module.exports = __webpack_public_path__ + "2020celebration/img/travel-r-1.ba2bd728.png";